import styled from "styled-components";
import Colors from "assets/Colors.js";

const Container = styled.div`
  min-height: 260px;
  height: 100%;
  width: 100%;
  // padding: 20px 17px;
  width: 100%;
  background: ${Colors.background_secondary};
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  max-width: 100vw;
  overflow: hidden;
  margin-bottom: 36px;
  @media (max-width: 768px) {
    height: 100%;
  }
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  height: 42px;
  padding-left: 17px;
  display: flex;
  align-items: center;
  color: ${Colors.text_on_primary};
  background: ${Colors.BG_Header_Card};
`;

const RoundColor = styled.div`
  height: 9.4px;
  min-height: 9.4px;
  width: 9.4px;
  min-width: 9.4px;
  border-radius: 50%;
  margin-right: 8.6px;
`;

const PaymentTypeText = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 11px;
  line-height: 13px;
  align-items: center;
  height: 13px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const ContainerColorPaymentType = styled.div`
  display: flex;
  align-items: center;
  width: 80%;
`;

const Money = styled.div`
  text-align: right;
  width: 20%;
  font-style: normal;
  font-weight: 300;
  font-size: 11px;
  line-height: 13px;
  align-items: center;
  color: ${Colors.text_dark};
`;

const MoneyLine = styled.div`
  border-top: 1px solid ${Colors.divider};
  ${(props) => props.last && `border-bottom: 1px solid ${Colors.divider};`}
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 26px;
  padding-right: 23px;
  padding-bottom: 17px;
  padding-top: 17px;
  @media (max-width: 768px) {
    margin-left: 20px;
  }
`;

const BodyContainer = styled.div`
  min-height: 260px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 20px 17px;
`;

const body = styled.div`
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const LeftBodyContainer = styled.div`
  min-width: 300px;
  width: 97%;
  margin-right: 20px;
`;

const pieChartContainer = styled.div`
  width: 140px;
  margin: 0 auto;
  @media (max-width: 768px) {
    margin-top: 30px;
  }
`;

export default {
  Container,
  Title,
  RoundColor,
  PaymentTypeText,
  ContainerColorPaymentType,
  Money,
  MoneyLine,
  BodyContainer,
  body,
  LeftBodyContainer,
  pieChartContainer,
};
